export const baseURL = "https://solyd-floors-back-end.vercel.app/api/v1"
